<div cdkDrag cdkDragRootElement=".cdk-overlay-pane"
     class="flex justify-between mb-4 ">
  <div cdkDragHandle class="p-2 grow font-semibold cursor-move">
    {{ title | titlecase }}
    <div class="handle"></div>
  </div>
  <span (click)="closeOpenModal()" class="hover:text-red-500 rounded-md flex items-center justify-center  cursor-pointer p-2"
        matTooltip="{{ 'Close' | concat | translate }}">
    <mat-icon>clear</mat-icon>
  </span>
</div>
